/** @format */

import React from 'react';
import {
  validatePassword,
  getPasswordStrength,
  getStrengthLabel,
  getStrengthColor,
} from '../utils/passwordRequirements';

interface PasswordRequirementsProps {
  password: string;
  showStrengthBar?: boolean;
}

/**
 * PasswordRequirements Component
 * Displays password requirements with visual feedback
 */
export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password,
  showStrengthBar = true,
}) => {
  const validation = validatePassword(password);
  const strength = getPasswordStrength(password);
  const strengthLabel = getStrengthLabel(strength);
  const strengthColor = getStrengthColor(strength);

  return (
    <div style={{ marginTop: '8px', marginBottom: '12px' }}>
      {/* Strength Bar */}
      {showStrengthBar && password.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '4px',
              fontSize: '12px',
            }}
          >
            <span>Password Strength</span>
            <span style={{ color: strengthColor, fontWeight: 500 }}>{strengthLabel}</span>
          </div>
          <div
            style={{
              width: '100%',
              height: '4px',
              backgroundColor: '#e8e8e8',
              borderRadius: '2px',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: `${strength}%`,
                height: '100%',
                backgroundColor: strengthColor,
                transition: 'width 0.3s ease, background-color 0.3s ease',
              }}
            />
          </div>
        </div>
      )}

      {/* Requirements List */}
      <div style={{ fontSize: '12px' }}>
        <span style={{ color: '#666', marginBottom: '4px', display: 'block' }}>
          Password must contain:
        </span>
        <ul style={{ margin: 0, paddingLeft: '20px', listStyle: 'none' }}>
          {validation.requirements.map((req) => (
            <li
              key={req.id}
              style={{
                color: req.met ? '#52c41a' : '#999',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                marginBottom: '2px',
              }}
            >
              <span style={{ fontSize: '14px' }}>{req.met ? '✓' : '○'}</span>
              <span>{req.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PasswordRequirements;
